import { z } from 'zod'

import { REQUIRED } from '@/shared/lib'

import type { SignInPayload } from './types'

export const signInSchema = z.object({
  email: z.string().min(1, REQUIRED),
  password: z.string().min(1, REQUIRED),
  /**
   * Unconstrained on purpose: the screen only asks for it once the backend has said the
   * account has 2FA on, and a rule here would refuse the first attempt — which is the
   * attempt that asks the question.
   */
  otpAttempt: z.string(),
  rememberMe: z.boolean()
})

export type SignInForm = z.infer<typeof signInSchema>

export const signInFormInitial = (): SignInForm => ({
  email: '',
  password: '',
  otpAttempt: '',
  rememberMe: true
})

export const buildSignInPayload = (
  form: SignInForm,
  captcha: string
): SignInPayload => ({
  email: form.email.trim().toLowerCase(),
  password: form.password,
  ...(form.otpAttempt ? { otpAttempt: form.otpAttempt } : {}),
  rememberMe: form.rememberMe,
  captcha
})
